export let SSR = "dlssr" as const;
export let SSR_DATA = SSR + "-d";
export let SSR_ID = SSR + "i";

export let CSS_IDENT = "dlcss-";
